import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../SharedModules/services/service';


export const dispatchValidateOrg = response => ({
    type:actionTypes.VALIDATE_ORG,
    validateOrgResponse : response
});

export const dispatchResetOrg = response => ({
    type: actionTypes.RESET_ALL_STATE,
    resetData : []
});

export const dispatchUserRolesUpdate = response => ({
    type:actionTypes.UPDATE_USER_ROLES,
    updateUserRoles : response
});
export const verifyOrgDetails = (data) => async dispatch => {
    return await axios.post(serviceEndPoint.VERIFY_ORG, data)
        .then(response => {
            if (response.status == "200") {
                dispatch(dispatchValidateOrg(response.data));
                if (response.data && response.data.statusCode == "01") {
                    dispatch(dispatchValidateOrg(response.data));
                }
            } else {
                dispatch(dispatchValidateOrg(response.data));
            }
        })
        .catch(error => {
            dispatch(dispatchValidateOrg(error));
        })
};


// add Organization FR Service

export const setOrgDetails = (data) => {
    return {
      type: actionTypes.ADD_ORGANIZATION,
      addOrgData: data
    };
  };

  export const getOrgDetails = (data) => {
    return {
      type: actionTypes.GET_ORGANIZATION,
      getOrgData: data
    };
  };
  
  // FR API
  /** Add Orgganization service call */
  export const addOrganizationForUser = (userId, orgData, addNPI) => {
    return dispatch => {
    return  axios.post(addNPI ? `${serviceEndPoint.ADD_ORG_USER}/${userId}?userAction=NPIADD` : `${serviceEndPoint.ADD_ORG_USER}/${userId}`, orgData)
    .then(response => {
        if (response.data.statusCode == "01") {
            dispatch(setOrgDetails(response.data));
        } else {
            dispatch(setOrgDetails(response.data));
        }
    })
    .catch(error => {
        dispatch(setOrgDetails(error));
    })
  }
  };

  /** Get Orgganization service call */
  export const getOrganizationForUser = (userId) => async dispatch => {
    var endPoint = serviceEndPoint.GET_ORG_USER + '/' + userId
    return await axios.get(endPoint)
        .then(response => {
            if (response) {
                dispatch(getOrgDetails(response.data));
            } else {
                dispatch(getOrgDetails(response.data?.message));
            }
        })
        .catch(error => {
            dispatch(getOrgDetails(error));
        })
};

  // Fuse API
  export const updateUserRolesAction = (data, orgId) => async dispatch => {
    var reqBody = {
        FS_User_Roles__c : JSON.stringify(data.userRoles)
    }
    var endPoint = serviceEndPoint.USER_ROLES_UPDATE + '/' +  orgId
    return await axios.patch(endPoint, reqBody)
        .then(response => {
            if (response) {
                dispatch(dispatchUserRolesUpdate(response.data));
            } else {
                dispatch(dispatchUserRolesUpdate(response.data?.message));
            }
        })
        .catch(error => {
            dispatch(dispatchUserRolesUpdate(error));
        })
};
